export default {"src":"/_next/static/media/WDC.44570855.svg","height":18,"width":18};